import { signupResultLayoutStyles } from '../SignupResultLayout/SignupResultLayout.styles';

export const signupCheckEmailStyles = {
  resultMessage: signupResultLayoutStyles.resultMessage,
  resultActions: signupResultLayoutStyles.resultActions,
};
